import { RefObject, useMemo, useSyncExternalStore } from 'react';

function subscribe(callback: (e: Event) => void) {
  window.addEventListener('resize', callback);
  return () => {
    window.removeEventListener('resize', callback);
  };
}

function emptySubscribe() {
  return () => {};
}

function useDimensions(ref: RefObject<HTMLElement>, enabled: boolean = true) {
  const dimensions = useSyncExternalStore(enabled ? subscribe : emptySubscribe, () => {
    if (!enabled) {
      return JSON.stringify({ width: 0, height: 0 });
    } else {
      return JSON.stringify({
        width: ref.current?.offsetWidth ?? 0,
        height: ref.current?.offsetHeight ?? 0,
      });
    }
  });
  return useMemo(() => JSON.parse(dimensions), [dimensions]);
}

export { useDimensions };
